<template>
  <kanbanWrap>
    <kanbanselect-group @groups="groups"></kanbanselect-group>
    <Row :gutter="16">
      <Col span="8">
        <div class="block" style="height: 300px">
          <h2 class="title">资产统计</h2>
          <div class="chartWrap">
            <zongzichan ref="zongzichan"></zongzichan>
          </div>
        </div>
        <div class="block" style="height: 280px">
          <h2 class="title">
            车辆里程统计<startEnd
              @startend="$refs.licheng.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <licheng ref="licheng"></licheng>
          </div>
        </div>
        <div class="block" style="height: 330px">
          <h2 class="title">
            车辆油耗排行<startEnd
              @startend="$refs.youhao.reach($event)"
            ></startEnd>
          </h2>
          <div class="chartWrap">
            <youhao ref="youhao"></youhao>
          </div>
        </div>
      </Col>
      <Col span="16">
        <div class="block" style="height: 950px; position: relative">
          <ecmap ref="ecmap"></ecmap>
          <mapMenu @mapData="reMapMenu" ref="mapMenu"></mapMenu>
        </div> </Col
      >
    </Row>

  </kanbanWrap>
</template>
<script>
import startEnd from "./statrEnd.vue";
import kanbanWrap from "../kanbanWrap.vue";
import youhao from "./youhao.vue";
import licheng from "./licheng.vue";
import xunchache from "./xunchache.vue";
import saodiche from "./saodiche.vue";
import zongzichan from "./pie";
import ecmap from "./ecmap.vue";
import paigongzonglan from "./paigongzonglan.vue";
import cheliangbaojing from "./cheliangbaojing.vue";
import paigongxiangmu from "./paigongxiangmu.vue";
import mapMenu from "./mapMenu.vue";
import kanbanselectGroup from "./kanbanselectGroup.vue";
export default {
  components: {
    zongzichan,
    startEnd,
    kanbanWrap,
    youhao,
    licheng,
    xunchache,
    saodiche,
    ecmap,
    paigongzonglan,
    cheliangbaojing,
    paigongxiangmu,
    mapMenu,
    kanbanselectGroup,
  },

  data() {
    return {};
  },
  methods: {
    reMapMenu(v, m) {
      if (m == "巡查点") {
        setTimeout(() => {
          this.$refs.ecmap.showLjt(v);
        }, 1500);
      } else if (m == "作业人员") {
        setTimeout(() => {
          this.$refs.ecmap.showpersons(v);
        }, 1500);
      } else if (m == "作业车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showXisao(v);
        }, 1500);
      } else if (m == "作业网格") {
        this.$refs.ecmap.showWangge(v);
      } else if (m == "巡查车辆") {
        setTimeout(() => {
          this.$refs.ecmap.showQingyun(v);
        }, 1500);
      } else if (m == "作业线路") {
        setTimeout(() => {
          this.$refs.ecmap.showline(v);
        }, 500);
      }
    },
    groups(v) {
      
      if (v[0].name == "广东华政建设有限公司") {
        v = [];
      }
      //this.$refs.paigongxiangmu.groups(v);
      //this.$refs.paigongzonglan.groups(v);
      this.$refs.licheng.groups(v);
      this.$refs.youhao.groups(v);
      this.$refs.zongzichan.groups(v);
      this.$refs.mapMenu.groups(v);
    },
  },
  mounted() {},
};
</script>

<style lang="">
#big {
  width: 1920px;
  height: 1080px;
  padding: 0 16px;
  transform-origin: 0 0;
}
#big p,
#big div {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/index.vue